import React from 'react';
import { IconButton, Menu, MenuItem, Button, useMediaQuery, useTheme } from '@material-ui/core';
import { AccountCircle } from '@material-ui/icons';
import { FormattedMessage } from 'react-intl';
import { getAuthProvider } from '../../../../Auth/AuthProvider';
import { useStyles } from './LogoutButton.styles';

export const LogoutButton = () => {
  const theme = useTheme();
  const isMdUp = useMediaQuery((theme) => (theme as any).breakpoints.up('md'));
  const isSmDown = useMediaQuery((theme) => (theme as any).breakpoints.down('sm'));
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const classes = useStyles();

  const handleLogout = () => {
    const authProvider = getAuthProvider();
    localStorage.clear();
    authProvider.logout();
  };

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      {/* Desktop */}
      {isSmDown && (
        <Button onClick={handleLogout} className={classes.root}>
          <FormattedMessage 
            id="component.sidebar.logout" 
            defaultMessage="Log out" 
            description="Label for Logout-button" 
          />
        </Button>
      )}
      
      {/* Tablet & Mobile */}
      {isMdUp && (
        <div className={classes.menu}>
          <IconButton
            className={classes.iconButton}
            onClick={handleClick}
            aria-controls="simple-menu"
            aria-haspopup="true"
          >
            <AccountCircle />
          </IconButton>
          <Menu
            id="simple-menu"
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={handleClose}
            getContentAnchorEl={null}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
          >
            <MenuItem onClick={handleLogout}>
              <FormattedMessage 
                id="component.sidebar.logout" 
                defaultMessage="Log out" 
                description="Label for Logout-button" 
              />
            </MenuItem>
          </Menu>
        </div>
      )}
    </>
  );
};